var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTestTube = function SvgIconTestTube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.832 2.293a1 1 0 0 0-1.414 0L3.23 14.479a4.44 4.44 0 0 0-.001 6.29 4.44 4.44 0 0 0 6.29 0l7.296-7.296q.018-.016.033-.034l3.19-3.19 2.027-.675a1 1 0 0 0 .39-1.656zm-1.356 9.692 3.317-3.317a1 1 0 0 1 .39-.242l.715-.238-3.773-3.774-6.718 6.718c.692.09 1.461.309 2.29.723 1.288.644 2.272.62 2.899.481a3 3 0 0 0 .723-.26q.108-.058.157-.091m-8.453 1.53-2.379 2.38h-.001a2.44 2.44 0 0 0 0 3.46l-.706.707.709-.705a2.44 2.44 0 0 0 3.458 0l.001-.002 4.988-4.988c-.693-.089-1.461-.308-2.29-.723-1.288-.644-2.272-.62-2.899-.48a3 3 0 0 0-.723.26 2 2 0 0 0-.158.092",
    clipRule: "evenodd"
  })));
};
export default SvgIconTestTube;